import React, { useState, useEffect } from "react";
import AuthUser from "../../services/AuthUser";

const FileUploadForm = ({ onUploadSuccess }) => {
  const [files, setFiles] = useState([]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const { http, token } = AuthUser();
  

  useEffect(() => {
    if (error || successMessage) {
      setShowAlert(true); // show alert initially

      const hideTimer = setTimeout(() => {
        setShowAlert(false); // trigger fade-out
      }, 3000); // fade out after 3 seconds

      const clearTimer = setTimeout(() => {
        setError("");
        setSuccessMessage("");
      }, 4000); // fully remove after fade

      return () => {
        clearTimeout(hideTimer);
        clearTimeout(clearTimer);
      };
    }
  }, [error, successMessage]);


  useEffect(() => {
    const agent = JSON.parse(localStorage.getItem("agent"));
    const user = JSON.parse(localStorage.getItem("user"));

    if (agent && agent.email) {
      setEmail(agent.email);
      setName(agent.user_id || "Agent");
    } else if (user && user.email) {
      setEmail(user.email);
      setName(user.user_id || "User");
    } else {
      setError("User not found.");
    }
  }, []);

  const handleFileChange = (e) => {
    setFiles(Array.from(e.target.files));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !email || files.length === 0) {
      setError("Please select at least one file.");
      return;
    }

    const formData = new FormData();
    formData.append("doc_id", name);
    formData.append("email", email);
    files.forEach((file) => {
      formData.append("documents[]", file);
    });

    try {
      const response = await http.post("/upload-files", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setSuccessMessage(response.data.message);
      setFiles([]);
      if (onUploadSuccess) {
        onUploadSuccess(); // 🔁 Trigger refresh in parent
      }
    } catch (error) {
      setError("File upload failed! Please try again.");
      console.error(error);
    }
  };

  return (
    <div className="container mt-4">
      <h4>Upload Documents</h4>

   



      <form onSubmit={handleSubmit}>
        <div className="form-groupp">
          <label></label>
          <input
            type="file"
            className="form-control-file"
            multiple
            onChange={handleFileChange}
            required
          />
        </div>

        {files.length > 0 && (
          <div className="mt-3">
            <h6>Selected Files:</h6>
            <ul className="list-group">
              {files.map((file, index) => (
                <li key={index} className="list-group-item">
                  {file.name}
                </li>
              ))}
            </ul>
          </div>
        )}

    <div className="mssg-cont d-flex gap-3 align-items-center mt-3 ">
    <button type="submit" className="btn btn-success ">
          Upload
        </button>
        {error && (
        <div className={`alert alert-danger fade mb-0 px-1 py-0  ${showAlert ? 'show' : ''}`} role="alert">
          {error}
        </div>
      )}
      {successMessage && (
        <div className={`alert alert-success fade mb-0 px-1 py-0 ${showAlert ? 'show' : ''}`} role="alert">
          {successMessage}
        </div>
      )}
    </div>
      </form>
    </div>
  );
};

export default FileUploadForm;
